'use client'

import { createContext, useContext } from 'react'
import { defaultQualityCopy, type QualityCopy } from '@/lib/i18n/quality-copy'

export const QualityCopyContext = createContext<QualityCopy>(defaultQualityCopy)

/** Shared operator components retain English defaults outside the main app. */
export function useQualityCopy() {
  return useContext(QualityCopyContext)
}
